import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {handleErrorResponse} from "../utils/util"
import { USER_ROLE } from "../constants/index"
import { ControlService } from "../api/services.gen";
import {
    ControlApiCompanyListData,
    ControlApiCompanyDestroyData,
    ControlApiCompanyCreateData,
    ControlApiCompanyRetrieveData,
    ControlApiCompanyUpdateData,
    ControlApiDepartmentListData,
    ControlApiPositionListData,
    ControlApiDepartmentUpdateData,
    ControlApiDepartmentDestroyData,
    ControlApiDepartmentCreateData,
    ControlApiPositionUpdateData,
    ControlApiPositionDestroyData,
    ControlApiPositionCreateData,
    ControlApiCompanyExportCsvRetrieveData,
} from "../api/types.gen";
import {INTERNAL_SERVER_ERROR} from "../constants/index";
import i18n from 'i18next';
import { resetAppState } from "../store/common";

export const getCustomerCompanyList = createAsyncThunk(
    "getCustomerCompanyList",
    async (data: ControlApiCompanyListData, thunkAPI: any) => {
        try {
            const res: any = await ControlService.controlApiCompanyList(data);
            if (res.results.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.CONTROL, thunkAPI);
        }
    },
);

export const getDefaultCompanyId = createAsyncThunk(
    "getDefaultCompanyId",
    async (_, thunkAPI: any) => {
        try {
            const res: any = await ControlService.controlApiCompanyGetDefaultCompanyIdRetrieve();
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.CONTROL, thunkAPI);
        }
    },
);

export const createCustomerCompany = createAsyncThunk(
    "createCustomerCompany",
    async (data: ControlApiCompanyCreateData, thunkAPI: any) => {
        try {
            const res: any = await ControlService.controlApiCompanyCreate(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.CONTROL, thunkAPI);
        }
    },
);

export const getCustomerCompanyDetail = createAsyncThunk(
    "getCustomerCompanyDetail",
    async (data: ControlApiCompanyRetrieveData, thunkAPI: any) => {
        try {
            const res: any = await ControlService.controlApiCompanyRetrieve(data);
            if (res.id) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.CONTROL, thunkAPI);
        }
    },
);

export const updateCustomerCompanyDetail = createAsyncThunk(
    "updateCustomerCompanyDetail",
    async (data: ControlApiCompanyUpdateData, thunkAPI: any) => {
        try {
            const res: any = await ControlService.controlApiCompanyUpdate(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.CONTROL, thunkAPI);
        }
    },
);

export const deleteCustomerCompanyDetail = createAsyncThunk(
    "deleteCustomerCompanyDetail",
    async (data: ControlApiCompanyDestroyData, thunkAPI: any) => {
        try {
            const res: any = await ControlService.controlApiCompanyDestroy(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.CONTROL, thunkAPI);
        }
    },
);

export const getDepartmentOfCompany = createAsyncThunk(
    "getDepartmentOfCompany",
    async (data: ControlApiDepartmentListData, thunkAPI: any) => {
        try {
            const res: any = await ControlService.controlApiDepartmentList(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.CONTROL, thunkAPI);
        }
    },
);

export const createDepartmentOfCompany = createAsyncThunk(
    "createDepartmentOfCompany",
    async (data: ControlApiDepartmentCreateData, thunkAPI: any) => {
        try {
            const res: any = await ControlService.controlApiDepartmentCreate(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.CONTROL, thunkAPI);
        }
    },
);

export const updateDepartmentOfCompany = createAsyncThunk(
    "updateDepartmentOfCompany",
    async (data: ControlApiDepartmentUpdateData, thunkAPI: any) => {
        try {
            const res: any = await ControlService.controlApiDepartmentUpdate(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.CONTROL, thunkAPI);
        }
    },
);

export const deleteDepartmentOfCompany = createAsyncThunk(
    "deleteDepartmentOfCompany",
    async (data: ControlApiDepartmentDestroyData, thunkAPI: any) => {
        try {
            const res: any = await ControlService.controlApiDepartmentDestroy(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.CONTROL, thunkAPI);
        }
    },
);

export const getPositionOfCompany = createAsyncThunk(
    "getPositionOfCompany",
    async (data: ControlApiPositionListData, thunkAPI: any) => {
        try {
            const res: any = await ControlService.controlApiPositionList(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.CONTROL, thunkAPI);
        }
    },
);

export const createPositionOfCompany = createAsyncThunk(
    "createPositionOfCompany",
    async (data: ControlApiPositionCreateData, thunkAPI: any) => {
        try {
            const res: any = await ControlService.controlApiPositionCreate(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.CONTROL, thunkAPI);
        }
    },
);

export const updatePositionOfCompany = createAsyncThunk(
    "updatePositionOfCompany",
    async (data: ControlApiPositionUpdateData, thunkAPI: any) => {
        try {
            const res: any = await ControlService.controlApiPositionUpdate(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.CONTROL, thunkAPI);
        }
    },
);

export const deletePositionOfCompany = createAsyncThunk(
    "deletePositionOfCompany",
    async (data: ControlApiPositionDestroyData, thunkAPI: any) => {
        try {
            const res: any = await ControlService.controlApiPositionDestroy(data);
            if (res.success) {
                return res;
            } else {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.CONTROL, thunkAPI);
        }
    },
);

export const exportCompanyCsv = createAsyncThunk(
    "exportCompanyCsv",
    async (data: ControlApiCompanyExportCsvRetrieveData, thunkAPI: any) => {
        try {
            const res: any = await ControlService.controlApiCompanyExportCsvRetrieve(data);
            if (res.success === false) {
                if(res.message) return thunkAPI.rejectWithValue(res.message);
                else return thunkAPI.rejectWithValue(i18n.t('MSG_GLOBAL_DATA_LOAD_FAILED'));
            }
            return res;
        } catch (error: any) {
            return handleErrorResponse(error, USER_ROLE.CONTROL, thunkAPI);
        }
    },
);

export interface TableHeader {
    title: string;
    isSort: boolean;
    field: string;
    currentSortState: number;
    customStyle: string;
}

const initTableHeaders = [
    {
        title: "ID",
        isSort: true,
        field: "id",
        currentSortState: 0,
        customStyle: "w-[80px]",
    },
    {
        title: "企業名",
        isSort: true,
        field: "name",
        currentSortState: 0,
        customStyle: "",
    },
    {
        title: "契約開始日",
        isSort: true,
        field: "contract_started_at",
        currentSortState: 0,
        customStyle: "w-[144px]",
    },
    {
        title: "契約期限",
        isSort: true,
        field: "expired_at",
        currentSortState: 0,
        customStyle: "w-[144px]",
    },
    {
        title: "状態",
        isSort: true,
        field: "is_active",
        currentSortState: 0,
        customStyle: "w-[120px]",
    },
    {
        title: "登録\nタレント数",
        isSort: true,
        field: "number_talent_register",
        currentSortState: 1,
        customStyle: "",
    },
]

// Initial state of Redux
interface SuperUserState {
    loading: boolean;
    error: string | null;
    success: string | null;
    actionName: string | null;
    actionStatus: string;
    companyList: [];
    countItems: number;
    currentPage: number;
    pageSize: number;
    sortBy: string | null;
    sortOrder: string | null;
    searchQuery: string | null;
    totalResults: number;
    tableHeaders: TableHeader[];
    detailData: [];
    initDepartmentList: [] | any;
    initPositionList: [];
    isReloadDepartment: boolean;
    isReloadPosition: boolean;
    defaultCompanyId: number;
    passCheckPage: string;
    isSearch: boolean;
}

const initialState: SuperUserState = {
    loading: false,
    error: null,
    success: null,
    actionName: null,
    actionStatus: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    companyList: [],
    countItems: 0,
    currentPage: 1,
    pageSize: 10,
    sortBy: "number_talent_register",
    sortOrder: "desc",
    searchQuery: "",
    totalResults: 0, 
    tableHeaders: initTableHeaders,
    detailData: [],
    initDepartmentList: [],
    initPositionList: [],
    isReloadDepartment: false,
    isReloadPosition: false,
    defaultCompanyId: 0,
    passCheckPage: "checking", // 'checking' | 'passed' | 'failed'
    isSearch: false,
};

const sortingStates = ["default", "desc", "asc"];

export const customerCompanySlice = createSlice({
    name: "customerCompany",
    initialState,
    reducers: {
        setSuccess: (state, action) => {
            state.success = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        setSearchQuery: (state, action) => {
            state.searchQuery = action.payload;
        },
        handleSortByHeader(state, action) {
            const sortHeader = action.payload;
            state.tableHeaders = state.tableHeaders.map((header, idx) => (header.field === sortHeader.field)
            ? ({...header, currentSortState: (header.currentSortState + 1) % sortingStates.length})
            : ({...header, currentSortState: 0}));
            
            if((sortHeader.currentSortState + 1) % sortingStates.length !== 0) {
                state.sortBy = sortHeader.field;
                state.sortOrder = sortingStates[(sortHeader.currentSortState + 1) % sortingStates.length];
            } else {
                state.sortBy = null;
                state.sortOrder = null;
            }
        },
        setIsSearch: (state, action) => {
            state.isSearch = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
        // reset state
        .addCase(resetAppState, () => initialState)

        // getCustomerCompanyList
        .addCase(getCustomerCompanyList.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(getCustomerCompanyList.fulfilled, (state, action) => {
            state.loading = false;
            state.companyList = action.payload.results?.data;
            state.totalResults = action.payload.results?.total_records;
            state.countItems = action.payload.count;
        })
        .addCase(getCustomerCompanyList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // getDefaultCompanyId
        .addCase(getDefaultCompanyId.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = null;
        })
        .addCase(getDefaultCompanyId.fulfilled, (state, action) => {
            state.loading = false;
            state.defaultCompanyId = action.payload.data.company_id;
        })
        .addCase(getDefaultCompanyId.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // createCustomerCompany
        .addCase(createCustomerCompany.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = null;
            state.actionName = "createCustomerCompany";
        })
        .addCase(createCustomerCompany.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.message;
            state.detailData = action.payload.data;
        })
        .addCase(createCustomerCompany.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // getCustomerCompanyDetail
        .addCase(getCustomerCompanyDetail.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = null;
            state.actionName = "getCustomerCompanyDetail";
            state.actionStatus = "pending";
        })
        .addCase(getCustomerCompanyDetail.fulfilled, (state, action) => {
            state.loading = false;
            state.detailData = action.payload;
            state.actionStatus = "fulfilled";
            state.passCheckPage = "passed";
        })
        .addCase(getCustomerCompanyDetail.rejected, (state, action) => {
            state.loading = false;
            // state.error = action.payload as string;
            state.actionStatus = "rejected";
            state.passCheckPage = "failed";
        })

        // updateCustomerCompanyDetail
        .addCase(updateCustomerCompanyDetail.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = null;
        })
        .addCase(updateCustomerCompanyDetail.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.message;
            state.detailData = action.payload.data;
        })
        .addCase(updateCustomerCompanyDetail.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // deleteCustomerCompanyDetail
        .addCase(deleteCustomerCompanyDetail.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = null;
            state.actionName = "deleteCustomerCompanyDetail";
        })
        .addCase(deleteCustomerCompanyDetail.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.message;
        })
        .addCase(deleteCustomerCompanyDetail.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // getDepartmentOfCompany
        .addCase(getDepartmentOfCompany.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = null;
        })
        .addCase(getDepartmentOfCompany.fulfilled, (state, action) => {
            state.loading = false;
            state.initDepartmentList = action.payload.data.map((item: any) => ({
                ...item,
                isActive: false,
                error: false,
            }));
        })
        .addCase(getDepartmentOfCompany.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // createDepartmentOfCompany
        .addCase(createDepartmentOfCompany.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = null;
        })
        .addCase(createDepartmentOfCompany.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.message;
            state.isReloadDepartment = !state.isReloadDepartment;
        })
        .addCase(createDepartmentOfCompany.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // updateDepartmentOfCompany
        .addCase(updateDepartmentOfCompany.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = null;
        })
        .addCase(updateDepartmentOfCompany.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.message;
            state.isReloadDepartment = !state.isReloadDepartment;
        })
        .addCase(updateDepartmentOfCompany.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // deleteDepartmentOfCompany
        .addCase(deleteDepartmentOfCompany.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = null;
        })
        .addCase(deleteDepartmentOfCompany.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.message;
            state.isReloadDepartment = !state.isReloadDepartment;
        })
        .addCase(deleteDepartmentOfCompany.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // getPositionOfCompany
        .addCase(getPositionOfCompany.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = null;
        })
        .addCase(getPositionOfCompany.fulfilled, (state, action) => {
            state.loading = false;
            state.initPositionList = action.payload.data.map((item: any) => ({
                ...item,
                isActive: false,
                error1: false,
                error2: false,
            }));
        })
        .addCase(getPositionOfCompany.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // createPositionOfCompany
        .addCase(createPositionOfCompany.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = null;
        })
        .addCase(createPositionOfCompany.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.message;
            state.isReloadPosition = !state.isReloadPosition;
        })
        .addCase(createPositionOfCompany.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // updatePositionOfCompany
        .addCase(updatePositionOfCompany.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = null;
        })
        .addCase(updatePositionOfCompany.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.message;
            state.isReloadPosition = !state.isReloadPosition;
        })
        .addCase(updatePositionOfCompany.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        }) 

        // deletePositionOfCompany
        .addCase(deletePositionOfCompany.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = null;
        })
        .addCase(deletePositionOfCompany.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.message;
            state.isReloadPosition = !state.isReloadPosition;
        })
        .addCase(deletePositionOfCompany.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })

        // exportCompanyCsv
        .addCase(exportCompanyCsv.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.success = null;
        })
        .addCase(exportCompanyCsv.fulfilled, (state, action) => {
            state.loading = false;
            state.success = action.payload.message;
        })
        .addCase(exportCompanyCsv.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as string;
        })
    }
});
export const {
    setSuccess,
    setError,
    setCurrentPage,
    setSearchQuery,
    handleSortByHeader,
    setIsSearch,
} = customerCompanySlice.actions;
export default customerCompanySlice.reducer;













